import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "card border-0 rounded-0 bg-white seller-card" }
const _hoisted_2 = { class: "card-body letter-spacing" }
const _hoisted_3 = { class: "fs-18 fw-semibold text-black mb-5 mb-md-8" }
const _hoisted_4 = ["innerHTML"]
const _hoisted_5 = {
  key: 0,
  class: "list mt-15 mt-lg-25 ps-0 mb-0 list-unstyled d-flex justify-content-between"
}
const _hoisted_6 = { class: "d-block text-dark-emphasis text-uppercase fw-medium fs-12 mb-5 mb-md-8" }
const _hoisted_7 = { class: "d-block text-dark fw-bold" }
const _hoisted_8 = { class: "d-block text-dark-emphasis text-uppercase fw-medium fs-12 mb-5 mb-md-8" }
const _hoisted_9 = { class: "d-block text-dark fw-bold" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h5", _hoisted_3, _toDisplayString(_ctx.center.name), 1 /* TEXT */),
      _createElementVNode("p", {
        class: "small text-muted",
        innerHTML: _ctx.center.address
      }, null, 8 /* PROPS */, _hoisted_4),
      (_ctx.stats)
        ? (_openBlock(), _createElementBlock("ul", _hoisted_5, [
            _createElementVNode("li", null, [
              _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.$t('feature.home.$stats.total_patients')), 1 /* TEXT */),
              _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.stats?.patients_total ?? ''), 1 /* TEXT */)
            ]),
            _createElementVNode("li", null, [
              _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.$t('feature.home.$stats.total_caregivers')), 1 /* TEXT */),
              _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.stats?.patients_with_caregiver ?? ''), 1 /* TEXT */)
            ])
          ]))
        : _createCommentVNode("v-if", true)
    ])
  ]))
}